import LRU from 'lru-cache'
import { EditorElementsPath, withCache } from '@wix/thunderbolt-commons'
import { FetchFn, Logger, MetricsReporter } from '@wix/thunderbolt-becky-types'
import { RemoteWidgetStructureBuilderPath } from '@wix/thunderbolt-byref'

export const getFileExtension = (path: string) => {
	if (!path) {
		return ''
	}
	const urlAfterLastSlash = path.split('/').pop()!
	return urlAfterLastSlash.slice(((urlAfterLastSlash.lastIndexOf('.') - 1) >>> 0) + 2)
}

const withReporting = (fetchFn: FetchFn, metricsReporter: MetricsReporter, logger: Logger) => {
	return (url: string) => {
		const fileExtension = getFileExtension(url)
		if (
			fileExtension !== 'svg' &&
			!url.includes(RemoteWidgetStructureBuilderPath) &&
			!url.includes(EditorElementsPath) &&
			!(
				(url.endsWith('siteAssets.manifest.min.json') ||
					url.endsWith('manifest.min.json') ||
					url.endsWith('.metadata.json') ||
					url.endsWith('siteAssets.bundle.js')) &&
				url.includes('editor-elements')
			)
		) {
			logger.warn(`BeckyFetch should be fetching svg | ${url}`)
		}
		return metricsReporter.runAsyncAndReport(() => fetchFn(url), `fetchInBecky|${fileExtension}`)
	}
}

export const BeckyFetch = (
	fetch: FetchFn,
	metricsReporter: MetricsReporter,
	logger: Logger,
	options: LRU.Options<string, string> = { max: 300 }
): FetchFn => {
	const { ...lruOptions } = options
	const cache = new LRU<string, string>(lruOptions)
	return withCache(withReporting(fetch, metricsReporter, logger), cache)
}
